import { render, staticRenderFns } from "./seleceSalegoods.vue?vue&type=template&id=2fc50128&scoped=true"
import script from "./seleceSalegoods.vue?vue&type=script&lang=js"
export * from "./seleceSalegoods.vue?vue&type=script&lang=js"
import style0 from "./seleceSalegoods.vue?vue&type=style&index=0&id=2fc50128&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc50128",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc50128')) {
      api.createRecord('2fc50128', component.options)
    } else {
      api.reload('2fc50128', component.options)
    }
    module.hot.accept("./seleceSalegoods.vue?vue&type=template&id=2fc50128&scoped=true", function () {
      api.rerender('2fc50128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aftersale/seleceSalegoods.vue"
export default component.exports